import styled from "styled-components";
import {Link} from "../../../../../raw-components/link/link";
import {ACTIVE} from "../../../../../../themes/css-global-classes";

export const LiveCasinoArenaNavbarButtonDefaultBox = styled(Link)`
  display: flex;
  transition: color 0.15s ease;
  align-items: center;
  font-weight: 500;

  &:hover {
    cursor: pointer;
  }
  
  color: ${props => props.theme.components.newLiveCasino.colors.filterButtonLabel};
  &:hover {
    color: ${({theme}) => theme.colors.textLight};
  }
  &.${ACTIVE} {
    color: ${({theme}) => theme.colors.brandPrimary};
    font-weight: 700;
  }
`;
